<template>
 	<b-container fluid class="sous_block">
        <b-row>
            <b-col cols="9"><p class="text-justify">This box displays the number of mutations with a GnomAD and/or Dolphin frequency localized in the selected {{dataDisplay.prot_dom}} protein domains of the {{dataDisplay.gene}} gene.</p></b-col>

            <b-col cols="3">
                <!-- <b-button class="button_hide_show btn-theme" v-on:click="showdiv=!showdiv">Hide/Show</b-button> -->
                <b-button style="float: right;" class="button_hide_show btn-theme" v-on:click="showdiv=!showdiv" :pressed.sync="button" ><div v-if="button">Hide</div><div v-else >Show</div></b-button>
            </b-col>
            <!-- <b-col cols="4"><h3 style="text-align: center;" >Domain Mutations Frequencies</h3></b-col> -->
        </b-row>
 		
        
 		<div id="fv1" :style="displaydiv" class="skylign" ref="featViewer"></div>
 	</b-container>
</template>
<script>
import FeatureViewer from 'feature-viewer';
 	export default {
 		props: {
            entryId: String,
 			seqInfo: [Object,Array],
            dataDisplay: Object
 		},
        data(){
            return {
                //myToggle: false,
                showdiv:true,
                ft: null,
                button: true,
            }
        },
 		mounted() {
      		console.log('FEATURE VIEWER Component mounted.')
            this.delete_all_features()
      		this.create_feature()
	    },
        computed:{
            displaydiv(){
                return {
                    display : this.showdiv ? "block" : "none"
                }
            }
        },
	    watch: {
          ft:{
            handler(){
                //console.log(this.ft);
            },
            deep: true
          }
    	},
    	methods:{
    		create_feature(){
                let vm = this
                axios
                  .get("/main/get_prot_seq/"+this.entryId)
                  .then( ({data}) => {
                    this.ft = new FeatureViewer(data,'#fv1',{
                        showAxis: true,
                        showSequence: true,
                        brushActive: true,
                        zoomMax:10,
                        dottedSequence: true,
                        units: "AA",
                        vm : vm,
                        exon_start: 0,
                        exon_end: 0,
                        realStart: 0,
                        strand: 1
                    });

                    this.create_freq_features(this.ft,vm);

                  })
                  .catch(error => console.log(error));
    			
    		},

    		create_freq_features(ft,vm){
    			
    			var tab_nb_gnomad_freq = []
    			var tab_nb_dolphin_freq = []
    			$.each(this.seqInfo, function(k,v){

                    tab_nb_gnomad_freq[k] = []
                    tab_nb_dolphin_freq[k] = []

    				ft.addFeature({
	    				data: v.domstartstop,
	    				name: k,
	    				className: "Domain_Viewer_"+k,
	    				color: "#32CD32",
	    				type: "rect",
	    				units: "AA",
                        height: 12,
                        isLegend : false,
                        // threshold: 0
    				})

    				$.each(v.nb_gnomad_freq, function(key,val){
    					tab_nb_gnomad_freq[k].push({x:val.pos_in_prot,y:val.count});
    				})

    				ft.addFeature({
	    				data: tab_nb_gnomad_freq[k],
	    				name: "Gnomad freq",
	    				className: "Nb_GnomAd_Viewer_"+k,
	    				color: "#FFB90F",
	    				type: "line",
	    				interpolation: 'step',
	    				units: "Missense mutation",
                        height: 150,
                        isLegend : false,
                        // threshold: 0
                        
    				})

    				$.each(v.nb_dolphin_freq, function(key,val){
    					tab_nb_dolphin_freq[k].push({x:val.pos_in_prot,y:val.count});
    				})

    				ft.addFeature({
	    				data: tab_nb_dolphin_freq[k],
	    				name: "Dolphin freq",
	    				className: "Nb_dolphin_Viewer_"+k,
	    				color: "#1472ba",
	    				type: "line",
	    				interpolation: 'step',
	    				units: "Missense mutation",
                        height: 150,
                        isLegend : false,
                        // threshold: 0
    				})

                    //console.log(this.ft)
    			})
    		},
    		delete_all_features(){
    			$("#fv1").empty();
    		}

	    }
	    
	}


// var dataDemo = [];
// for (var i=1;i<100;i++) {
//     var count = Math.floor((Math.random() * 20) + 1);
//     dataDemo.push({
//         x: i*2,
//         y:count
//     })
// }
// ft2.addFeature({
//     data: dataDemo,
//     name: "test feature 5",
//     className: "test5",
//     color: "#008B8D",
//     type: "line",
//     filter: "type2",
//     height: "5"
// });



                





</script>